import 'application/templates/root.router';

import 'application/templates/login/login.router';

import 'application/templates/forgot-password/forgot-password.router';

import 'application/templates/default/default.router';

import 'application/templates/default/inner/otherwise/otherwise.router';

import 'application/templates/default/inner/publications/publications.router';

import 'application/templates/default/inner/publications/inner/publications-details/publications-details.router';

import 'application/templates/default/inner/processes/processes.router';

import 'application/templates/default/inner/processes/inner/processes-details/processes-details.router';

import 'application/templates/default/inner/processes/inner/processes-create/processes-create.router';

import 'application/templates/default/inner/subpoena/subpoena.router';

// import 'application/templates/default/inner/dashboard/dashboard.router';

import 'application/templates/default/inner/account/account.router';

import 'application/templates/reset-password/reset-password.router';
